<template>
  <div class="view-container">
    <div class="card">
      <div class="card-content">
        <figure class="image"><img src="@/assets/logo.png" alt="" /></figure>
        <input-field
          label="Mobile"
          type="tel"
          required
          v-model="mobile"
        ></input-field>
        <input-field
          label="Password"
          type="password"
          required
          v-model="password"
        ></input-field>
        <div class="has-text-centered" style="padding-top: 12px;">
          <p class="has-text-danger">{{ message }}</p>
          <p class="has-text-danger">{{ error }}</p>
          <button
            class="button is-primary"
            :disabled="!isValid"
            @click="onLoginClicked"
            :class="{ 'is-loading': fetching }"
          >
            Login
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mobile: "",
      password: "",
      message: "",
      error: "",
      fetching: false
    };
  },
  computed: {
    isMobileValid() {
      return this.mobile.length > 8 && this.mobile.length < 14;
    },
    isPasswordValid() {
      return this.password.length > 3;
    },
    isValid() {
      return this.isMobileValid && this.isPasswordValid;
    }
  },
  methods: {
    onLoginClicked() {
      let component = this;
      component.fetching = true;
      component.$store
        .dispatch("auth/login", {
          mobile: component.mobile,
          password: component.password
        })
        .then(response => {
          component.fetching = false;
          component.$store.commit("setNavVisible", true);
          component.$store.commit("user/search", "");
          component.$router.push("/dashboard");
        })
        .catch(error => {
          component.fetching = false;
          component.message = error.response
            ? error.response.data.message
            : "Unknown error";

          if (
            error &&
            (error.response.status === 404 || error.response.status === 401)
          ) {
            component.message = error.response.data.message;
          } else {
            component.message = "Unknown Error";
          }
        });
    }
  },
  mounted() {
    let component = this;
    if (localStorage.getItem("token")) {
      component.$store.commit("setNavVisible", true);
      component.$router.push("/dashboard");
    } else {
      component.$store.commit("setNavVisible", false);
    }
  }
};
</script>
<style lang="scss" scoped>
.view-container {
  height: 100%;
  background: $grey-lighter;
  .card {
    width: 400px;
    margin: auto;
    top: 50%;
    margin-top: -200px;
  }
}
</style>
